<template>
    <div>
        <v-simple-table dense v-for="(tipoProyecto, key) in tiposProyectoFiltrados(idCotizacion)"
                        :key="'tipoProyecto-' + key">
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="tituloTipoProyecto">
                        {{ tipoProyecto.fields.nombre }}
                    </th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="(proyecto, key) in proyectosFiltrados(idCotizacion, tipoProyecto.id)" :key="'proyecto-' + key">
                        <td class="pr-0">
                            <Proyecto :proyecto="proyecto" />
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Proyecto from "@/components/Detalle/Proyecto";

export default {
    name: "TipoProyecto",
    components: {Proyecto},
    props: {
        idCotizacion: {
            required: true,
        }
    },
    computed: {
        ...mapGetters(['tiposProyectoFiltrados', 'proyectosFiltrados'])
    }
}
</script>

<style scoped>
.tituloTipoProyecto {
    font-family: "Expressway Rg", sans-serif;
    font-size: 110%;
    line-height: 1.8;
    background: #EBEBEB;
    padding-left: 25px;
    font-weight: normal !important;
}
</style>
